import styled from 'styled-components'
import {Link} from 'react-scroll'



export const Button = styled.button`
    border-radius: 50px;
    background: ${({primary}) => (primary ? '#EF3D3B' : '#232C63')};
    white-space: nowrap;
    padding: ${({big}) => (big ? '14px 48px' : '12px 30px')};
    color: ${({dark}) => (dark ? '#EF3D3B' : '#F6B519')};
    font-size: ${({fontBig}) => (fontBig ? '20px' : '16px')};
    outline: none;
    min-width: 100px;
    border: none;
    cursor:pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover{
        transition: all 0.2s ease-in-out;
        color: #EF3D3B;
        background: ${({primary}) => (primary ? '#232c63': '#232c63')};
        text-decoration:none;
    }
`

export default Button